$(document).ready(function(){
  $(".quantity__button").on("click",function(){
    var pdp_qty_value = parseInt($(".product__info-container .product-form__quantity quantity-input input").val());
    var pdp_ticket = $(".price_with_cst_data .cus_ticket").data("ticket");
    if (!isNaN(pdp_ticket * pdp_qty_value)) $(".cus_ticket").text(pdp_ticket*pdp_qty_value);
  });
  
  let totalTickets = 0;
  $(".cart-item").each(function(){
    var total_ticket = $(this).find(".cus_tickitnumber").data("ticket_no");
    if (!isNaN(total_ticket)) {
      totalTickets += parseInt(total_ticket, 10);
    }
  });
  $(".totaal-ticket-count").text(totalTickets+" Tickets");

    // hero Slider
    $('.hero-slideshow .slider-wrapper').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0586/0186/5554/files/angle-left.svg?v=1749809879' /></button>",
        nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0586/0186/5554/files/angle-right.svg?v=1749809879' /></button>"
    });

    // hero Slider
    $('.collection .products-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0586/0186/5554/files/angle-left.svg?v=1749809879' /></button>",
        nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0586/0186/5554/files/angle-right.svg?v=1749809879' /></button>",
        dots: true,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }
        ]
    });
});


$(document).ready(function(){
  $(".cst_pay_btn").on("click",function(){
    $(".cart__checkout-button.button").trigger("click");
  });

//   document.querySelectorAll('.varint-label').forEach((label, index) => {
//   label.addEventListener('click', () => {
//     console.log(`Clicked varint-label #${index + 1}:`, label);

//     setTimeout(() =>{
//               const ticketEl = document.querySelector('.cus_ticket');
//             if (ticketEl) {
//               const ticketValue = ticketEl.getAttribute('data-ticket');
//               console.log('Ticket Value:', ticketValue);

//               const inputEl = document.getElementById('form_ticket');
//               inputEl.value = `${ticketValue} Tickets`;
//             } else {
//               console.log('No .cus_ticket element found');
//             }
//     }, 800)
    
//   });
// });

});